module.exports = __webpack_public_path__ + "31b54bb9c1c5b7a64e9c301ddc7aa731.png";